module.exports = __webpack_public_path__ + "media/A15.400fd9dc.mp3";